import React, { useEffect } from "react";

import axios from "axios";
import { useMercadopago } from "react-sdk-mercadopago";

const CheckoutMP = ({ item }) => {
  const mercadopago = useMercadopago.v2(
    "APP_USR-389835eb-efa0-4f5f-83d0-e81977867e31", // public key test user (seller)
    { locale: "es-CL" }
  );

  useEffect(() => {
    const createPayment = async () => {
      const URL = "https://api.mercadopago.com/checkout/preferences";
      const ACCESS_TOKEN =
        "APP_USR-5991847454479975-101911-2ff7092279663baf559d58a85ccea34a-1207702249"; // test user (seller)
      const preferences = {
        items: [item],
        // item's attributes
        // {
        //     "id": "item-ID-1234",
        //     "title": "Mi producto", // REQUIRED
        //     "currency_id": "ARS",
        //     "picture_url": "https://www.mercadopago.com/org-img/MP3/home/logomp3.gif",
        //     "description": "Descripción del Item",
        //     "category_id": "art",
        //     "quantity": 1, // REQUIRED
        //     "unit_price": 75.76 // REQUIRED
        // }
        back_urls: {
          failure: "http://localhost:3000/",
          pending: "http://localhost:3000/",
          success: "http://localhost:3000/",
        },
      };

      try {
        const { data } = await axios.post(URL, preferences, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${ACCESS_TOKEN}` },
        });
        mercadopago.checkout({
          preference: { id: data.id },
          render: { container: ".cho-container", label: "Pagar" },
        });
      } catch (err) {
        console.log(err);
      }
    };

    if (mercadopago) createPayment();
  }, [mercadopago]);

  return <div className="cho-container"></div>;
};

export default CheckoutMP;
